import type { FieldValue, JiraComponentsFieldInput } from './types.tsx';

export const mutateComponentsField = (
	selectedComponents: FieldValue,
): JiraComponentsFieldInput => ({
	components: selectedComponents.reduce(
		(
			acc: {
				componentId: string | null;
			}[],
			{ value },
		) => {
			if (value !== null) {
				acc.push({ componentId: value });
			}
			return acc;
		},
		[],
	),
});
